import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { EVENTS } from '../events-page/data-events';

@Component({
  selector: 'app-events-details-page',
  templateUrl: './events-details-page.component.html',
  styleUrls: ['./events-details-page.component.scss']
})
export class EventsDetailsPageComponent implements OnInit {
  eventCode: string;
  event: any;
  events = EVENTS;

  elementHtml: any;

  public _album = [];
  constructor(
    public _lightbox: Lightbox,
    private route: ActivatedRoute
  ) { 
    // this.event.galleria.forEach(element => {
      
    // });
    // for (let i = 1; i <= 6; i++) {
    //   const src = 'assets/images/events/gallery/events1/gallery' + i + '.jpg';
    //   const caption = 'Image ' + i;
    //   const thumb = 'assets/images/events/gallery/events1/gallery' + i + '.jpg';
    //   const album = {
    //       src: src,
    //       caption: caption,
    //       thumb: thumb
    //   };
    //   this._album.push(album);
    // }

    // this._album = this.event.galleria;
   }

  ngOnInit(): void {
    this.eventCode = this.route.snapshot.params.code;
    this.event = this.events.find( ev => ev.code === this.eventCode );

    this._album = this.event.galleria;

    this.elementHtml = document.getElementById('desc');
    this.elementHtml.innerHTML = this.event.description;
  }

  open(index: number): void {
      // open lightbox
      this._lightbox.open(this._album, index);
  }

  close(): void {
      // close lightbox programmatically
      this._lightbox.close();
  }

}
